import { modals } from '@mantine/modals';

import { UTBReport } from './UTBReport';

export const reportModalManager = {
  openUTB: (batchId: string, title: string) =>
    modals.open({
      title,
      size: '80vw',
      children: <UTBReport batchId={batchId} />,
    }),
};
